<template>
  <div>
    <div class="wrapper wrapper-full-page">
      <div
        style="
          position: absolute;
          background-color: #fff;
          width: 100%;
          height: 200px;
          z-index: 1000;
        "
      >
        <div
          style="
            background-color: #fbe54d;
            width: 200px;
            height: 300px;
            z-index: 1000;
            margin-left: 20px;
            border-radius: 300px 0 0 0;
          "
        >
          <h1 style="padding-top: 100px; margin-left: 100px; font-weight: 800">
            SOLARMAP
          </h1>
        </div>
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          height: 60px;
          width: 100%;
          z-index: 10000;
          background-color: #fff;
          text-align: right
        "
      >
      <img src="/img/ufsm.png" class="mx-2" style="height: 100%" alt="">
      <img src="/img/nic.png" class="mx-2" style="height: 100%" alt="">
      <img src="/img/inct.png" class="mx-2" style="height: 100%" alt="">
      <!--<img src="/img/inri.png" class="mx-2" style="height: 100%" alt="">-->
      </div>
      <div
        class="page-header login-page header-filter"
        filter-color="black"
        style="
          background-image: url('../../img/solar-panels.jpg');
          background-size: cover;
          background-position: top center;
        "
      >
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-8 col-sm-10 ml-auto mr-auto">
              <div class="card card-login">
                <div class="card-body">
                  <span class="bmd-form-group">
                    <div class="input-group mt-4">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="material-icons">email</i>
                        </span>
                      </div>
                      <input
                        id="email"
                        type="email"
                        class="form-control"
                        placeholder="Email"
                        v-model="formData.email"
                      />
                    </div>
                  </span>
                  <span class="bmd-form-group">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="material-icons">lock_outline</i>
                        </span>
                      </div>
                      <input
                        id="password"
                        type="password"
                        class="form-control"
                        placeholder="Senha"
                        v-model="formData.password"
                      />
                    </div>
                  </span>
                  <div style="margin-top: 10px">
                    <span
                      v-show="error"
                      style="margin-left: 55px; font-weight: bold; color: red"
                      >{{ error }}</span
                    >
                  </div>
                </div>
                <div class="card-footer justify-content-center">
                  <button
                    v-on:click="login"
                    style="width: 200px; background: #4054b2; color: #fff"
                    class="btn btn-lg"
                  >
                    ACESSAR
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <footer class="footer" sty style="background-color: #fff !important">
          <div class="container">
            <div class="copyright float-right">
              <a href="https://ideatos.com.br" target="_blank">&copy; IDEATOS2222</a>
            </div>
          </div>
        </footer> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      error: null,
      formData: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    login() {
      callAPI(
        "/login",
        "POST",
        this.formData,
        (e) => {
          this.error = null;
          console.log(e);
          localStorage.setItem("token", e.request.token);
          window.location = "/";
        },
        (e) => {
          this.error = e.responseJSON.message;
        },
        (e) => {
          console.log("Error");
          console.log(e);
        }
      );
    },
  },
};
</script>
